import React from 'react';
import PageNotFound404 from '../../components/notfound/NotFound';

const PageNotFound = () => {
  return <PageNotFound404 />;
};

export default PageNotFound;
